module.exports = __webpack_public_path__ + "img/logo-ftd.0ed0109d.svg";